import { useState, useEffect } from "react"
import $api from "@/api"
import { classModuleGenerator } from "@/utils"
import styles from "../index.module.less"
import { connect } from "react-redux"

const classnames = classModuleGenerator(styles)

function College({ regionId }) {
  const [collegeList, setCollege] = useState([])
  useEffect(() => {
    const getCollegeList = async () => {
      const params = {
        index: 0,
        size: 50,
      }
      if (regionId) params.regionId = regionId
      const { result } = await $api.college.page(params)
      setCollege(result?.list || [])
    }
    getCollegeList()
  }, [regionId])
  return (
    <section className={classnames("college-container")}>
      <h3 className="section__title">中职院校</h3>
      <div className="section__inner">
        <ul className={classnames("college-list", "clearfix")}>
          {collegeList.map((model) => {
            return (
              <li
                key={model._id}
                style={{
                  background: `url(${model.coverUrl}) no-repeat center/cover`,
                }}
              >
                <h5>{model.name}</h5>
                <ul className={classnames("college-mask")}>
                  {["招生简章", "招生时间", "学校地址", "报名咨询"].map((m) => (
                    <li
                      key={m}
                      onClick={() => {
                        window.openJesongChatByGroup(121, 52601)
                        return false
                      }}
                    >
                      {m}
                    </li>
                  ))}
                </ul>
              </li>
            )
          })}
        </ul>
      </div>
    </section>
  )
}

// export default College
const mapStateToProps = (state) => {
  return {
    regionId: state.region.checked._id,
  }
}

export default connect(mapStateToProps)(College)
